import { createContext } from "react";

import type { LoadContextInt } from "@/types/contexts";

const LoadContext = createContext<LoadContextInt>({
  isLoading: false,
  message: "",
  setMessage: (_message: string) => {
    // This is intentional
  },
  setIsLoading: (_b: boolean) => {
    // This is intentional
  },
  openLoading: (_message: string) => {
    // This is intentional
  },
  closeLoading: () => {
    // This is intentional
  }
} as LoadContextInt);

export default LoadContext;
